<template>
  <header class="app-header">
    <router-link class="app-header__logo" to="/">{{ appNameEn }}</router-link>
    <!-- <a class="app-sidebar__toggle" href="#" @click.prevent="$emit('toggle-sidebar')" aria-label="Hide Sidebar"></a> -->
    <a class="app-sidebar__toggle" href="#" data-toggle="sidebar" aria-label="Hide Sidebar"></a>
    <ul class="app-nav">
      <!-- <li class="app-search">
        <input class="app-search__input" type="search" placeholder="Search">
        <button class="app-search__button"><i class="bi bi-search"></i></button>
      </li> -->
      <!-- Notification Bell -->
      <li class="dropdown">
        <a class="app-nav__item" href="#" data-bs-toggle="dropdown" aria-label="แสดงการแจ้งเตือน">
          <i class="bi bi-bell fs-5"></i>
        </a>
        <ul class="app-notification dropdown-menu dropdown-menu-right">
          <!-- If notifications exist -->
          <li class="app-notification__title">คุณมี 4 การแจ้งเตือนใหม่</li>
          <div class="app-notification__content">
            <li>
              <a class="app-notification__item" href="javascript:;">
                <span class="app-notification__icon">
                  <i class="bi bi-envelope fs-4 text-primary"></i>
                </span>
                <div>
                  <p class="app-notification__message">Lisa ส่งอีเมลถึงคุณ</p>
                  <p class="app-notification__meta">2 นาทีที่แล้ว</p>
                </div>
              </a>
            </li>
          </div>

          <!-- If no notifications (add this block for empty state) -->
          <!--
    <li class="app-notification__title text-center">ไม่มีการแจ้งเตือน</li>
    -->

          <li class="app-notification__footer">
            <a href="#">ดูการแจ้งเตือนทั้งหมด</a>
          </li>
        </ul>
      </li>

      <!-- User Menu -->
      <li class="dropdown" v-if="isAuthenticated">
        <a class="app-nav__item" href="#" data-bs-toggle="dropdown" aria-label="เปิดเมนูโปรไฟล์">
          <i class="bi bi-person fs-4"></i>
        </a>
        <ul class="dropdown-menu settings-menu dropdown-menu-right">
          <li>
            <router-link class="dropdown-item" to="/profile">
              <i class="bi bi-person me-2 fs-5"></i> โปรไฟล์
            </router-link>
          </li>
          <li>
            <a class="dropdown-item" href="#" @click.prevent="handleLogout">
              <i class="bi bi-box-arrow-right me-2 fs-5"></i> ออกจากระบบ
            </a>
          </li>
        </ul>
      </li>
      <li v-else>
        <router-link class="app-nav__item" to="/auth/login">เข้าสู่ระบบ</router-link>
      </li>

    </ul>
  </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'; // Import mapGetters and mapActions

export default {
  name: 'NavBar',
  emits: ['toggle-sidebar'], // Declare the event this component can emit
  computed: {
    ...mapGetters(['isAuthenticated']), // Map getters from the store
  },
  data() {
    return {
      appName: process.env.VUE_APP_NAME,
      appNameEn: process.env.VUE_APP_NAME_EN,
    };
  },
  methods: {
    ...mapActions(['logout']), // Map the 'logout' action from the store

    async handleLogout() {
      try {
        await this.logout(); // Dispatch the logout action
        this.$router.push('/auth/login'); // Redirect to login page after logout
      } catch (error) {
        // Handle logout error, if any
        console.error('Logout failed:', error);
      }
    },
  },
};
</script>
<style scoped>
.app-header__logo {
  font-size: 22px;
}
</style>